import * as S from './styles';
import { CreditCard } from '@mui/icons-material';
import darkOrLightMode from '../../../utils/helpers/colorMode';
import QISignTheme from '../../../interfaces/Theme';
import { Icons } from '../types/severity';

declare type HeaderProps = {
    title?: string;
    description?: string;
    icon?: Icons;
    clientThemeSettings: QISignTheme;
}

export default function Header({ title, description, icon, clientThemeSettings }: HeaderProps) {
    const backgroundColor = clientThemeSettings.background_color;
    const iconColor = darkOrLightMode(backgroundColor) === 'light mode' ? '#232323' : '#FFFFFF';

    return (
        <S.Container>
            {icon === 'card' &&
                <S.IconWrapper $backgroundColor={backgroundColor}>
                    <CreditCard style={{ color: iconColor }} />
                </S.IconWrapper>
            }
            <S.TextWrapper>
                {title && <S.Title>{title}</S.Title>}
                {description && <S.Description>{description}</S.Description>}
            </S.TextWrapper>
        </S.Container>
    )
}